import APIrequest from "../lib/axios"
import { AdminAuthEndpoinst } from "../api/admin/auth.endpoints"

export const AuthService = {
    async login(data) {
        try {
            const payload = {
                ...AdminAuthEndpoinst.login,
                bodyData: data
            }
            const response = await APIrequest(payload);
            return response;
        } catch (error) {
            console.log(error)
        }
    }
}